export default class SupplierMessageData {
    supplierGuid: string;
    supplierName: string;
}